<template>
  <div class="error">
    <div class="title">{{ title }}</div>
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    title: String,
  },
});
</script>

<style lang="scss" scoped>
$color-bg: #e1e9f3;
.title {
  font-weight: bold;
}

.error {
  padding: 16px;
  border: 1px solid;
  z-index: 3;
  background-color: $color-bg;
  border-color: black;
}

a {
  text-decoration: underline;
}
</style>
